module.exports = __webpack_public_path__ + "img/swiper5.b88195d9.jpg";